import { useMedia } from 'react-use';
import { screen } from 'components/styles/variables';
import styles from './styles';

export default function Thumbnail({
  index,
  active,
  slidePage,
  onClick,
  setSlideIndex,
  onSlideChange,
  images,
}: {
  index: number;
  onClick: () => void;
  active: boolean;
  slidePage: number;
  setSlideIndex: (index: number) => void;
  onSlideChange: (index: number) => void;
  images: string[];
}): JSX.Element | null {
  /* 
    Sets up a sliding window to ensure 4 slides are rendered at a time
    slidePage is set by ThumbnailButtons, this boolean checks to ensure that the
    current Thumbnail falls within the slidePage
  */
  const shouldRender = index >= slidePage * 4 && index < slidePage * 4 + 4;
  const isMobile = useMedia(`(max-width: ${screen.xsMax})`, false);

  return shouldRender || isMobile ? (
    <>
      <button
        onClick={(e): void => {
          e.preventDefault();
          onClick();
          setSlideIndex(index);
          onSlideChange(index);
        }}
        className={`custom-dot ${active ? 'active' : ''}`}
        data-testid="ssr-carousel-thumbnail"
      >
        <img key={images[index]} src={images[index]} className="dot-image" />
      </button>
      <style>{styles}</style>
    </>
  ) : null;
}
